// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3isMP","empty":"ModalGraph_empty__2MZJr"};